(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/views/confirm.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/views/confirm.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


(function (svs, $, gsap) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  var DialogConfirm = function (_svs$components$dialo) {
    _inherits(DialogConfirm, _svs$components$dialo);

    var _super = _createSuper(DialogConfirm);

    function DialogConfirm(options) {
      var _this;

      _classCallCheck(this, DialogConfirm);

      _this = _super.call(this, options);
      _this.log = new svs.core.log.Logger('DialogConfirm');

      if (options.type === svs.components.dialog.type.ERROR) {
        options.branding = svs.components.dialog.branding.ERROR; 

        options.icon = 'exclamation-sign';
      }

      if (!options.branding) {
        throw new Error('This component must have a branding specified.');
      }

      var defaults = {
        branding: options.branding,
        title: options.title,
        icon: 'checkmark',
        autoClose: 0,
        convertToPopup: true,
        area: svs.components.dialog.area.POPUP,
        type: svs.components.dialog.type.CONFIRM,
        requireHandshake: false,
        handshakeTimeout: svs.components.dialog.handshakeTimeout.DEFAULT,
        _ContentClass: svs.components.dialog.Content
      };
      _this.options = $.extend(defaults, options);
      _this.currentHeight = undefined;
      _this.requireHandshake = _this.options.requireHandshake;
      _this.handshakeFailsafe = undefined;
      _this.handshakeTimeout = _this.options.handshakeTimeout;
      _this._isClosing = false;
      _this._id = new Date().getTime();
      _this.tl = {};

      _this.render();

      _this.setupAnimations();

      return _this;
    }

    _createClass(DialogConfirm, [{
      key: "hasRevealed",
      value: function hasRevealed() {
        var _this2 = this;

        this.log.debug("Dialog ".concat(this.options.title, " has revealed"));

        if (this.options.autoClose && this.type !== svs.components.dialog.type.ERROR) {
          this.timeout = setTimeout(function () {
            _this2.close();
          }, this.options.autoClose);
        } else {
          clearTimeout(this.timeout);
        } 


        this.keyEventsAdd();
        this.emit('revealed');

        this._buttons.setFocus();

        if (this.requireHandshake) {
          this.handshakeFailsafe = setTimeout(function () {
            _this2.requireHandshake = false;

            _this2.log.debug('Handshake timed out.');
          }, this.handshakeTimeout);
        }
      }
    }, {
      key: "keyEventsAdd",
      value: function keyEventsAdd() {
        var _this3 = this;

        this.log.debug('Add Keyboard Events');
        this.keyListenerId = svs.utils.keylistener.addKeyboardListener(function (event) {
          _this3.keyEventsListener(event);
        });
      }
    }, {
      key: "keyEventsRemove",
      value: function keyEventsRemove() {
        this.log.debug('Remove Keyboard Events');
        svs.utils.keylistener.removeKeyboardListener(this.keyListenerId);
      }
    }, {
      key: "keyEventsListener",
      value: function keyEventsListener(e) {
        if (e.keyCode === svs.utils.keylistener.KEY_ESC && this.allowDimmerClick) {
          this._buttons.triggerEscape();
        }
      }
    }, {
      key: "setupAnimations",
      value: function setupAnimations() {
        var _this4 = this;

        this.tl = gsap.timeline({
          paused: true,
          onComplete: function onComplete() {
            _this4.hasRevealed();
          },
          onReverseComplete: function onReverseComplete() {
            _this4.hasClosed();

            if (typeof _this4.onCloseCallback === 'function') {
              setTimeout(function () {
                _this4.onCloseCallback();
              }, 300);
            }
          }
        });
        this.tl.fromTo(this._content.el, {
          y: -10,
          autoAlpha: 0
        }, {
          duration: 0.15,
          y: 0,
          autoAlpha: 1
        });
        this.tl.fromTo(this._buttons.el, {
          opacity: 0,
          y: 50
        }, {
          duration: 0.15,
          opacity: 1,
          y: 0
        }, '-=.1');
      }
    }, {
      key: "next",
      value: function next() {
        this.log.debug('Open next confirm');
        this.tl.seek(0);
        this.tl.play().timeScale(2);
      }
    }, {
      key: "close",
      value: function close(callback) {
        this._isClosing = true;

        if (callback) {
          this.onCloseCallback = callback;
        } 


        clearTimeout(this.timeout);
        clearTimeout(this.handshakeFailsafe); 

        if (this.options.area === svs.components.dialog.area.TOASTER) {
          this.hasClosed();
        } else {
          this.tl.timeScale(2).reverse();
        }
      }
    }, {
      key: "reveal",
      value: function reveal() {
        if (this.options.area === svs.components.dialog.area.TOASTER) {
          this.tl.seek(this.tl.duration(), true);
        }

        this.tl.play();
      }
    }, {
      key: "setDimensions",
      value: function setDimensions() {
        this.height = this.el.offsetHeight;
        this.width = this.el.offsetWidth;
      }
    }, {
      key: "hide",
      value: function hide() {
        this.el.setAttribute('style', 'display: none');
      }
    }, {
      key: "hasClosed",
      value: function hasClosed() {
        this.log.debug('Dialog has closed');

        if (!this.requireHandshake) {
          this.keyEventsRemove();
          this.emit('closed');
        }
      }
    }, {
      key: "closed",
      value: function closed() {
        this.emit('hasClosed', {});
      }
    }, {
      key: "setScrollableHeight",
      value: function setScrollableHeight(h) {
        if (this.currentHeight !== h) {
          if (typeof h === 'string') {
            this.el.setAttribute('style', 'height: auto;');
          } else {
            this.el.setAttribute('style', "height: ".concat(h, "px;"));
          }

          this.currentHeight = h;

          this._content.testScrollArea();
        }
      }
    }, {
      key: "setAllowDimmerClick",
      value: function setAllowDimmerClick() {
        this.allowDimmerClick = true;

        if (this.options.area === svs.components.dialog.area.TOASTER || this.options.type === svs.components.dialog.type.ERROR || this.options.allowDimmerClick === false || this.options.actions && this.options.actions.length >= 2) {
          this.allowDimmerClick = false;
        }
      }
    }, {
      key: "resolveHandshake",
      value: function resolveHandshake() {
        clearTimeout(this.handshakeFailsafe);
        this.requireHandshake = false;
        this.close();
      }
    }, {
      key: "getContent",
      value: function getContent() {
        return new this.options._ContentClass(this.options);
      }
    }, {
      key: "createWrapper",
      value: function createWrapper() {
        this.el = document.createElement('div');
        this.el.className += 'js-dialog-item dialog-item f-content';
        this.el.setAttribute('id', 'dialog-confirm');
      }
    }, {
      key: "addButtons",
      value: function addButtons() {
        var _this5 = this;

        this._buttons = new svs.components.dialog.Buttons(this.options);

        this._buttons.on('close', this, function () {
          _this5.close();
        });

        this._buttons.on('callback', this, function (_ref) {
          var e = _ref.e,
              callback = _ref.callback;
          callback(e, _this5.el.getElementsByClassName('js-dialog-item-checkbox'), _this5);
        });

        this._buttons.on('scrollToEnd', this, function () {
          _this5._content.scrollToEnd();
        });

        this.el.appendChild(this._buttons.el);
      }
    }, {
      key: "addContent",
      value: function addContent() {
        var _this6 = this;

        this._content = this.getContent();
        this.el.appendChild(this._content.el);

        this._content.on('contentScrolling', this, function () {
          _this6._buttons.showScrollButton();
        });

        this._content.on('contentBottom', this, function () {
          _this6._buttons.hideScrollButton();
        });
      }
    }, {
      key: "render",
      value: function render() {
        this.createWrapper();

        if (this.options.type === svs.components.dialog.type.ERROR) {
          this.el.className += ' dialog-item-error';
        }

        this.el.className += " dialog-branding-".concat(this.options.branding);
        this.addContent();
        this.addButtons();
        this.setAllowDimmerClick();
      }
    }]);

    return DialogConfirm;
  }(svs.components.dialog.PubSub);

  svs.components.dialog.Confirm = DialogConfirm;
})(svs, $, gsap);
 })(window);